import { useState } from 'react'
import { TextInput, PasswordInput, Button, Container, Title, Text } from '@mantine/core'
import { signIn } from 'aws-amplify/auth'

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(null)

  const handleLogin = async () => {
    setError(null)
    try {
      // Cognito でメールアドレス + パスワード認証を行う
      const { isSignedIn } = await signIn({ username: email, password })
      if (isSignedIn) {
        // サインイン成功 → Hub.listen で App.jsx 側が状態を更新する
        onLogin()
      }
    } catch (e) {
      setError(e.message)
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleLogin()
  }

  return (
    <Container size="xs">
      <Title order={2} align="center" mb="md">Sign in to CloudHub</Title>
      <TextInput
        label="メールアドレス"
        placeholder="example@example.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onKeyDown={handleKeyDown}
        mb="sm"
      />
      <PasswordInput
        label="パスワード"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        onKeyDown={handleKeyDown}
        mb="sm"
      />
      <Button fullWidth onClick={handleLogin}>Sign in</Button>
      {error && <Text color="red" mt="sm">{error}</Text>}
    </Container>
  )
}
